import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateInventoryTransactionStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateInventoryTransactionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateInventoryTransactionStatusAttempt', handleUpdateInventoryTransactionStatus, api);
}

function* handleUpdateInventoryTransactionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateInventoryTransactionStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        inventoryLogId,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateInventoryTransactionStatus], {
        authToken,
        inventoryLogId,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateInventoryTransactionStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const pendingInventoryTransactionListing = reduxState.approval.pendingInventoryTransactionListing.data;
        const pendingInventoryTransactionListingIndex = reduxState.approval.pendingInventoryTransactionListing.index;
        const oldStatus = pendingInventoryTransactionListing.find(item => item.inventoryLogId === inventoryLogId)?.status;
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveTransactionSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectTransactionSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateInventoryTransactionStatusModalIsOpen(false));

        toast.success(successMessage);

        if (status === oldStatus) {
            yield put(combinedActions.approvalUpdateInventoryTransactionStatusSuccess());
            return;
        }

        if (pendingInventoryTransactionListing.length === 1) {
            yield put(combinedActions.approvalSetPendingTransactionListingIndex({ index: pendingInventoryTransactionListingIndex > 0 ? pendingInventoryTransactionListingIndex - 1 : 0 }));
        }

        yield put(combinedActions.approvalGetPendingInventoryTransactionListingAttempt());
        yield put(combinedActions.approvalUpdateInventoryTransactionStatusSuccess());
    }
}
